import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";
import { ProductsApi } from "../../client-identity";

export const useProductsAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, ProductsApi>) => {
  return useAPI<T, ProductsApi>({
    initialValue,
    APIClass: ProductsApi,
    handleRequest,
  });
};
